import { faItalic } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { InputRule } from "prosemirror-inputrules";
import { MarkType } from "prosemirror-model";

import { toggleMark } from "~/lib/prose/commands";

import { type KeysArgs, MarkExtension } from "../extension";
import { markActive } from "../utils";

// This regex ensures no whitespaces or additional underscores immediately after/before enclosing underscores
const italicRegexInputRule = /(^|[\W\s])_((?:(?!(\s_|_\s)).)*[^\s_])_([\W\s]|$)$/;
export default class ItalicMark extends MarkExtension {
	get name() {
		return "italic";
	}

	get mark() {
		return {
			parseDOM: [
				{ tag: "em" },
				{ tag: "i" },
				{ style: "font-style", getAttrs: (value: string) => value == "italic" && null },
			],
			toDOM() {
				return ["em", 0];
			},
		};
	}

	keys({ $type }: KeysArgs) {
		return {
			"Mod-i": toggleMark($type as MarkType, {}),
		};
	}

	inputRules() {
		return [
			new InputRule(italicRegexInputRule, function italicize(state, match, start, end) {
				const mark = state.schema.mark("italic");
				const codeBlockMark = state.schema.mark("code");

				//If the current text is already formatted as code, do not apply markdown formatting
				if (markActive(codeBlockMark)(state)) return null;

				//Account for multiple markdown symbols preceding the match, e.g. *_test_*
				const prefixSymbolCompensation = !match[0].startsWith("_") ? 1 : 0;

				return state.tr
					.insertText("", start + prefixSymbolCompensation, start + 1 + prefixSymbolCompensation)
					.insertText("", end, end)
					.addMark(start + prefixSymbolCompensation, end - 1, mark)
					.removeStoredMark(mark);
			}),
		];
	}

	menuEntry() {
		return {
			icon: faItalic,
			title: "Italic",
			run: () => toggleMark(this.$type, {}),
			section: "formatting" as const,
			group: "basic",
			priority: 4,
			keyboardShortcut: this.cmdPlus("I"),
		};
	}
}
